import * as _ from 'lodash';
import * as moment from 'moment';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Booking, Addon, AddonOption, OptionValueEntityInstance, Sector } from '../models/booking.model';
import { AddonsService } from 'app/shared/services/addons.service';
import { LocalStorageService } from './local-storage.service';
import { TravelProductService, GetCartTotalOptions, CartItemOptions, UpdateTourOnBookingOption } from './travel-product.service';
import { BookingService } from './booking.service';
import { InitialDataService } from '../../initial-data.service';
import { ErrorService } from './error.service';
import { GxConstants } from '../../shared/constants/gx.constants';
import { CartTotalService } from 'app/shared/services/cart-total.service';
import { ApplicationError } from 'app/shared/errors/ApplicationError';

@Injectable()
export class SectorAddonsService {

    private _booking: Booking;
    public addonCartSource = new BehaviorSubject(Array<Addon>());
    addonCart = this.addonCartSource.asObservable();
    public loadingCartTotalSource = new BehaviorSubject<boolean>(false);
    loadingCartTotal = this.loadingCartTotalSource.asObservable();
    public refreshSectorAddonsSource = new BehaviorSubject<boolean>(false);
    refreshSectorAddons = this.refreshSectorAddonsSource.asObservable();

    constructor(
        private addonsService: AddonsService,
        private localStorageService: LocalStorageService,
        private travelPackageService: TravelProductService,
        private bookingsService: BookingService,
        private initialDataService: InitialDataService,
        private errorService: ErrorService,
        private cartTotalService: CartTotalService
    ) {
    }

    setLoadingCartTotal(lct: boolean) {
        this.loadingCartTotalSource.next(lct);
    }

    assignOpenDatedAddonToSector(options: UpdateTourOnBookingOption){
        this.travelPackageService.updateTourOnBooking(options);
    }

    updateAddonsCart(booking: Booking, addons: Array<Addon>) {
        this._booking = booking;
        this.updateCartData(booking, addons);
    }

    setAddonsRefresh(refresh: boolean){
        console.log('sector.addons.service.ts: ' + refresh);
        this.refreshSectorAddonsSource.next(refresh);
    }

    updateCartData = (booking: Booking, addons: Array<Addon>) => {
        const selectedAddons = addons.filter(x => x.AddonOptions.findIndex(y => y.Selected) > -1),
        storeCartTotalInManagedBooking = () => {
            const success = ( data ) => {
                this.localStorageService.saveCart(data);
                const options = this.constructAddAddonOptions(selectedAddons);
                this.bookingsService.addAddonsToBooking(options).toPromise().then((result) => {
                    const updatedBooking = result;

                    this.localStorageService.saveOnlineBooking(updatedBooking);
                    this.addonCartSource.next(addons);
                });
            }, error = function () {
                throw new ApplicationError('Addons not added to booking.');
            }, loading = () => {
                this.setLoadingCartTotal(true);
            }, finished = () => {
                this.setLoadingCartTotal(false);
            }
            const cartTotalOptions = this.constructCartTotalOptions(selectedAddons);
            console.log(cartTotalOptions);
            return this.cartTotalService.postCartTotal(cartTotalOptions, success, error, loading, finished);
        };

        this.errorService.reset();
        storeCartTotalInManagedBooking();
    }

    private constructAddAddonOptions = selectedAddons => {
        const fareTypeOptions = [];
        selectedAddons.forEach(addon => {
            addon.AddonOptions.forEach(o => {
                o.OptionValueEntity.forEach(v => {
                    if(v.Selected && v.ProductCode != null){
                        fareTypeOptions.push(
                            {
                                AddonType: addon.AddonType,
                                FareTypeCode: v.ProductCode,
                                Amount: v.SalePriceUnit,
                                Quantity: o.Quantity,
                                Name: o.Quantity + " x " + v.SoldDescription,
                                UsageDate: moment(o.UsageDate,"DD/MM/YYYY hh:mm:SS A").format("YYYY-MM-DD hh:mm:SS A").toString()
                            }
                        );
                    }
                })
            })
        });
        return {
            BookingGUID: this._booking.BookingGuid,
            FareTypeOptions: fareTypeOptions
        }
    };

    private constructCartTotalOptions = selectedAddons => {

        const cartItems = [];
        selectedAddons.forEach(addon => {
            addon.AddonOptions.forEach(o => {
                o.OptionValueEntity.forEach(v => {
                    if(v.Selected && v.ProductCode != null && o.CanPurchase){
                        const cartItem = new CartItemOptions();
                        cartItem.productCode = v.ProductCode;
                        cartItem.Type = addon.AddonType;
                        cartItem.SalePriceUnit = v.SalePriceUnit;
                        cartItem.Quantity = o.Quantity;
                        cartItem.PromoCode = null;
                        cartItems.push(cartItem);
                    }
                })
            });
        });

        const options = new GetCartTotalOptions();
        options.BookingGUID = this._booking.BookingGuid;
        options.Passengers = Booking.getPassengerCountWithExclusions(this._booking);
        options.CartItems = cartItems;
        return options;
    };

}



// WEBPACK FOOTER //
// ./src/app/shared/services/sector-addons.service.ts